<template>
  <section class="pt-20">
    <div class="container">
      <div class="lg:w-4/5 pt-20">
        <h1 class="lg:text-5xl/snug text-3xl/snug mt-3">
          {{ blog.Title }}
        </h1>
      </div>
      <!-- featured image -->
      <div class="mt-8">
        <img
          :src="blog.FeaturedImage"
          alt="featured image"
          class="w-full h-96 object-cover rounded-lg"
        />
      </div>
    </div>
  </section>
  <section class="flex flex-col min-h-screen">
    <div class="container">
      <div v-html="blog.Content"></div>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { getPage } from "@/services/contentService";
import { useLoadingStore } from "@/stores/loadingStore";

// `setup` fonksiyonu içinde `useRoute`'u çağırıyoruz.
const route = useRoute();
const loadingStore = useLoadingStore();

var slug = route.path;

const blog = ref("");

// `slug` parametresini console'a yazdırıyoruz
loadingStore.startLoading();
getPage(slug).then((data) => {
  loadingStore.finishLoading();
  blog.value = data;
});
</script>
